import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AnimationsService } from '../animations.service';
import { API } from '../api';
import { ErrorHandlerService } from '../error-handler.service';
import { AuthService } from 'src/app/security/auth.service';

@Injectable({
  providedIn: 'root'
})
export class OutboundService {

  constructor(
    private http: HttpClient,
    private animationsService: AnimationsService,
    private errorHandlerService: ErrorHandlerService,
    private authService: AuthService,
  ) { }

  cadastrar(data): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(
      `${environment.baseUrl}${API.outbound.cadastrar}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
        .pipe(
          tap(() => this.animationsService.showProgressBar(false)),
          catchError(this.errorHandlerService.errorHandler(
            'Falha ao enviar os dados', [])
          )
        );
  }

  updateStatusAtendimento(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('idAtendimento', id);
    const usuario = this.authService.getToken();
    return this.http.get(
      `${environment.baseUrl}${API.outbound.updateStatus}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
        .pipe(
          tap(() => this.animationsService.showProgressBar(false)),
          catchError(this.errorHandlerService.errorHandler(
            'Falha ao atualizar status', [])
          )
        );
  }

  getOutbound(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('idUnidade', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.outbound.carregarOutbond}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Erro ao carregar Outbonds!', []))
      );
  }

  getHistoricoTentativa(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('idAtendimento', id);
    const usuario = this.authService.getToken();
    return this.http.get(
      `${environment.baseUrl}${API.outbound.historicoTentativa}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler(
          'Não existem Historico!', []
          )
        )
      );
  }

}
